module.exports = __webpack_public_path__ + "static/shar-cover-77e7ae7754b6bc136fb188e771d425a4.png";